import { Link } from "gatsby";
import * as React from "react";
import { ReactNode, useEffect, useState } from "react";

import Accordion from "../Accordion/Accordion";
import { SanityContentItem } from "../ContentList/ContentList";

interface Heading {
  type: string;
  text: string;
  id: string;
}

type PropsContentList = {
  data: { title?: string; indexList: SanityContentItem[] };
  settings?: { withAccordion?: boolean };
};

export const cleanEncodeAndCapitalize = (text: string) => {
  text = text.replace(/#?(\d+)\s*[\s.-]*/, "$1 ");
  text = capitalizeFirstLetter(text);
  text = text.replace(/\*\*/g, "");
  return text.toLowerCase().replace(/\s+/g, "-");
};

export const cleanAndCapitalize = (text: string) => {
  text = text.replace(/#?(\d+)\s*[\s.-]*/, "$1 ");
  return capitalizeFirstLetter(text);
};

const capitalizeFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const IndexOfHeadings: React.FC<PropsContentList> = ({ data, settings }) => {
  const withAccordion = settings?.withAccordion ?? false;
  const hasHeadings = (contentList: SanityContentItem) => {
    if (contentList.__typename === "SanityMd") {
      const item = contentList as Queries.SanityMd;
      return extractHeadings(item.value as string).length > 0;
    }
    return false;
  };

  const extractHeadings = (markdownContent: string): Heading[] => {
    const headings: Heading[] = [];
    const lines = markdownContent.split("\n");
    lines.forEach((line) => {
      if (line.startsWith("## ")) {
        const textWithLink = line.replace("## ", "");
        const match = textWithLink.match(/\[(.*?)]\((.*?)\)/);
        const text = match ? match[1] : textWithLink;
        const cleanedText = cleanAndCapitalize(text);
        const id = cleanedText.toLowerCase().replace(/\s+/g, "-");
        headings.push({ type: "h2", text: cleanedText, id });
      }
    });

    return headings;
  };
  function renderIndex(item: SanityContentItem, index: number): ReactNode {
    if (!hasHeadings(item))
      return <React.Fragment key={index}></React.Fragment>;
    return extractHeadings((item as Queries.SanityMd).value as string).map(
      (heading) => (
        <li key={heading.id}>
          <a href={`#${encodeURIComponent(heading.id)}`}>{heading.text}</a>
        </li>
      ),
    );
  }

  const postHasHeadings = data.indexList.some(hasHeadings);

  return (
    <div className="m-index-of-headings">
      {postHasHeadings &&
        (withAccordion ? (
          <Accordion resume={{ title: data.title ?? "Tabla de contenidos" }}>
            <ol className={"index-of-headings__list"}>
              {data.indexList.map((item, index) => renderIndex(item, index))}
            </ol>
          </Accordion>
        ) : (
          <div className={"m-index-of-headings__mobile"}>
            <div className="a-title">{data.title ?? "Tabla de contenidos"}</div>
            <ol className={"index-of-headings__list"}>
              {data.indexList.map((item, index) => renderIndex(item, index))}
            </ol>
          </div>
        ))}
    </div>
  );
};

export default IndexOfHeadings;
